import { Link, Outlet } from "react-router-dom";

/**
 * Sentinel Auth Layout — standalone branding for login/register pages.
 * Does NOT use E Industries' Navbar or Footer. Shows only Sentinel logo
 * and a minimal Sentinel-branded footer.
 */
export function SentinelAuthLayout() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "var(--bg-subtle)" }}>
      <header
        style={{
          padding: "var(--space-4) var(--space-6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid var(--border)",
          background: "var(--surface)",
        }}
      >
        <Link to="/dashboard" style={{ display: "flex", alignItems: "center", gap: "0.625rem" }}>
          <img src="/sentinel-white.png" alt="Sentinel" style={{ width: "32px", height: "32px", objectFit: "contain" }} />
          <span style={{ fontWeight: 800, fontSize: "1.125rem", color: "var(--text)", letterSpacing: "-0.01em" }}>
            Sentinel
          </span>
        </Link>
        <Link
          to="/"
          style={{ fontSize: "0.8125rem", color: "var(--text-muted)", textDecoration: "none" }}
        >
          Back to Homepage
        </Link>
      </header>

      <main style={{ flex: 1, display: "flex", flexDirection: "column" }}><Outlet /></main>

      <footer
        style={{
          padding: "var(--space-4) var(--space-6)",
          textAlign: "center",
          fontSize: "0.75rem",
          color: "var(--text-muted)",
          borderTop: "1px solid var(--border)",
          background: "var(--surface)",
        }}
      >
        Sentinel Certification Platform &mdash; Powered by E Industries
      </footer>
    </div>
  );
}
